export function getWindowProperty(name, defaultValue) {
    var store = window;
    if (store[name] === undefined && defaultValue != null) {
        store[name] = defaultValue();
    }
    return store[name];
}
export function setWindowProperty(name, value) {
    window[name] = value;
}
